class GoogleCookieConsentUpdater {
    cookieConsentData;
    consentTypesMapping;
    consentValuesMapping;

    constructor() {
        this.initialize();
        this.registerEventListeners();
    }

    initialize() {
        window.dataLayer = window.dataLayer || [];
        this.cookieConsentData = document.querySelector('[data-google-cookie-consent]');
        if (!this.cookieConsentData) {
            console.error("Nepodařilo se najít konfiguraci google consentu!");
        }

        const consentTypes = this.cookieConsentData.dataset.consentTypes;
        const consentValues = this.cookieConsentData.dataset.consentValues;
        if (!(consentTypes && consentValues)) {
            console.error("Nepodařilo se načíst konfiguraci google consentu, předaná data jsou pravděpodobně vadná!");
            return;
        }

        this.consentTypesMapping = JSON.parse(consentTypes);
        this.consentValuesMapping = JSON.parse(consentValues);
        EventBus.getInstance().addEventListener('cookiesConsentStored', (e) => this.onCookiesConsentStored(e.detail));
    }

    translateBoolToConsent(value) {
        return this.consentValuesMapping[Number(value)];
    }

    onCookiesConsentStored(ev) {
        const consents = {};
        this.consentTypesMapping.forEach(t => consents[t.name] = this.translateBoolToConsent(t.id === (t.id & ev.consent)));
        this.updateConsent(consents);
        window.dataLayer.push({event: 'consent_updated'}); // Týká se měřících značek v GTM, které nejsou od Googlu
    }

    updateConsent(consents) {
        if (typeof gtag === "undefined") {
            console.error("Funkce gtag() nebyla inicializována. Nelze odeslat update consentu!");
            return;
        }

        gtag("consent", "update", consents);
    }

}

document.addEventListener('DOMContentLoaded', () => {
    new GoogleCookieConsentUpdater();
});
